import { c as _c } from "react/compiler-runtime";
import MoreInfo from '@/sections/MoreInfo';
import PageHeadline from '../PageHeadline';
import { Layout } from './Layout';
import React from 'react';
import IconDeferredPayment from '@/assets/icons/heroIcons/Deferred-payment.svg';
import IconThird from '@/assets/icons/heroIcons/Icon-third.svg';
import IconCard from '@/assets/icons/heroIcons/Card-front.svg';
import { LINKS } from '@/constants/links';
import { useTranslation } from 'react-i18next';
import { SectionDelimiter } from '../SectionDelimiter';
import { ContentContainer } from './ContentContainer';
import SeoPageLayoutSection from './SeoPageLayoutSections';
import { RenderButtonProps } from '../buttons';
import { Button } from '../buttons';
import { QuickMenu, useQuickMenu } from '../QuickMenu';
import { SeoHeader } from '@/components/SeoHeader';
import { PageMenuPromoBanner } from '@/api/sanity/pageMenuPromoBanner';
import IconMaxi from '@/assets/icons/heroIcons/Maxi.svg';
export function SeoPageLayout(t0) {
  const $ = _c(80);
  const {
    intro,
    introButton,
    sections,
    title,
    seo,
    menuPromoBanners
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["core"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  const {
    activeSection,
    setActiveSection,
    handleScrollToSection,
    getSectionId,
    getSubsectionSectionId
  } = useQuickMenu();
  let t2;
  if ($[1] !== seo) {
    t2 = seo && <SeoHeader {...seo} />;
    $[1] = seo;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="bgCircle absolute top-0 left-0 hidden h-[30rem] w-[30rem] -translate-x-1/2 -translate-y-1/2 rotate-180 lg:block lg:h-[50rem] lg:w-[50rem] lg:-translate-x-1/3 lg:-translate-y-1/3" />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== title) {
    t4 = <PageHeadline id="title" text={title} className="lg:max-w-none xl:text-center" />;
    $[4] = title;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== intro) {
    t5 = <div className="mt-6 text-base lg:mt-8 lg:text-xl">{intro}</div>;
    $[6] = intro;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== introButton?.to) {
    t6 = introButton?.to ?? LINKS().registration;
    $[8] = introButton?.to;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== introButton?.label || $[11] !== t) {
    t7 = introButton?.label ?? t("core:seo.tryItButton");
    $[10] = introButton?.label;
    $[11] = t;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t6 || $[14] !== t7) {
    t8 = <Button variant="primary" to={t6} testId="seoIntro" analyticsParam="seoIntro" className="mt-10 lg:mt-14" align="center" size="md">{t7}</Button>;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t4 || $[17] !== t5 || $[18] !== t8) {
    t9 = <div className="bg-blue-100 px-4 pt-[7.5rem] pb-14 text-center lg:pt-64 lg:pb-[7.5rem]">{t3}<div className="mx-auto max-w-292">{t4}{t5}{t8}</div></div>;
    $[16] = t4;
    $[17] = t5;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <SectionDelimiter color="bg-blue-50" background="bg-blue-100" />;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== activeSection || $[22] !== getSectionId || $[23] !== getSubsectionSectionId || $[24] !== handleScrollToSection || $[25] !== sections) {
    t11 = <QuickMenu activeSection={activeSection} getSectionId={getSectionId} getSubsectionSectionId={getSubsectionSectionId} handleScrollToSection={handleScrollToSection} sections={sections} />;
    $[21] = activeSection;
    $[22] = getSectionId;
    $[23] = getSubsectionSectionId;
    $[24] = handleScrollToSection;
    $[25] = sections;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== getSectionId || $[28] !== getSubsectionSectionId || $[29] !== sections || $[30] !== setActiveSection) {
    let t13;
    if ($[32] !== getSectionId || $[33] !== getSubsectionSectionId || $[34] !== setActiveSection) {
      t13 = (t14, i) => {
        const {
          content,
          title: title_0,
          subsections
        } = t14;
        const sectionId = getSectionId(title_0.toString());
        return <><SeoPageLayoutSection key={`content${i}`} title={title_0} content={content} sectionId={sectionId} i={i} onScroll={setActiveSection} />{subsections?.map((subsection, subI) => <SeoPageLayoutSection key={`subcontent${subI}`} title={subsection.title} content={subsection.content} sectionId={getSubsectionSectionId(sectionId, subsection.title.toString())} i={subI} onScroll={setActiveSection} />)}</>;
      };
      $[32] = getSectionId;
      $[33] = getSubsectionSectionId;
      $[34] = setActiveSection;
      $[35] = t13;
    } else {
      t13 = $[35];
    }
    t12 = sections.map(t13);
    $[27] = getSectionId;
    $[28] = getSubsectionSectionId;
    $[29] = sections;
    $[30] = setActiveSection;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  let t13;
  if ($[36] !== t12) {
    t13 = <div className="relative w-full">{t12}</div>;
    $[36] = t12;
    $[37] = t13;
  } else {
    t13 = $[37];
  }
  let t14;
  if ($[38] !== t11 || $[39] !== t13) {
    t14 = <div className="bg-blue-50 px-4 pt-12 pb-20 lg:pt-10 lg:pb-40"><ContentContainer><div className="flex flex-col items-start gap-16 lg:flex-row lg:gap-20">{t11}{t13}</div></ContentContainer></div>;
    $[38] = t11;
    $[39] = t13;
    $[40] = t14;
  } else {
    t14 = $[40];
  }
  let t15;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <SectionDelimiter color="bg-blue-100" background="bg-blue-50" />;
    $[41] = t15;
  } else {
    t15 = $[41];
  }
  let t16;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <IconDeferredPayment className="fillButtonIcon" />;
    $[42] = t16;
  } else {
    t16 = $[42];
  }
  let t17;
  if ($[43] !== t) {
    t17 = t("core:products.deferredPayment");
    $[43] = t;
    $[44] = t17;
  } else {
    t17 = $[44];
  }
  let t18;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = LINKS();
    $[45] = t18;
  } else {
    t18 = $[45];
  }
  let t19;
  if ($[46] !== t17) {
    t19 = {
      analyticsParam: "seoMoreInfoDeferredPayment",
      icon: t16,
      testId: "seoMoreInfoDeferredPayment",
      title: t17,
      to: t18.deferredPayment
    };
    $[46] = t17;
    $[47] = t19;
  } else {
    t19 = $[47];
  }
  let t20;
  if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <IconMaxi className="fillButtonIcon" />;
    $[48] = t20;
  } else {
    t20 = $[48];
  }
  let t21;
  if ($[49] !== t) {
    t21 = t("core:products.revolving");
    $[49] = t;
    $[50] = t21;
  } else {
    t21 = $[50];
  }
  let t22;
  if ($[51] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = LINKS();
    $[51] = t22;
  } else {
    t22 = $[51];
  }
  let t23;
  if ($[52] !== t21) {
    t23 = {
      analyticsParam: "seoMoreInfoRevolvingApplication",
      icon: t20,
      testId: "seoMoreInfoRevolvingApplication",
      title: t21,
      to: t22.revolving
    };
    $[52] = t21;
    $[53] = t23;
  } else {
    t23 = $[53];
  }
  let t24;
  if ($[54] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <IconThird className="fillButtonIcon" />;
    $[54] = t24;
  } else {
    t24 = $[54];
  }
  let t25;
  if ($[55] !== t) {
    t25 = t("core:products.payInThree");
    $[55] = t;
    $[56] = t25;
  } else {
    t25 = $[56];
  }
  let t26;
  if ($[57] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = LINKS();
    $[57] = t26;
  } else {
    t26 = $[57];
  }
  let t27;
  if ($[58] !== t25) {
    t27 = {
      analyticsParam: "seoMoreInfoPayInThree",
      icon: t24,
      testId: "seoMoreInfoPayInThree",
      title: t25,
      to: t26.payInThree
    };
    $[58] = t25;
    $[59] = t27;
  } else {
    t27 = $[59];
  }
  let t28;
  if ($[60] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = <IconCard className="fillButtonIcon" />;
    $[60] = t28;
  } else {
    t28 = $[60];
  }
  let t29;
  if ($[61] !== t) {
    t29 = t("core:products.card");
    $[61] = t;
    $[62] = t29;
  } else {
    t29 = $[62];
  }
  let t30;
  if ($[63] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = LINKS();
    $[63] = t30;
  } else {
    t30 = $[63];
  }
  let t31;
  if ($[64] !== t29) {
    t31 = {
      analyticsParam: "seoMoreInfoCard",
      icon: t28,
      testId: "seoMoreInfoCard",
      title: t29,
      to: t30.card
    };
    $[64] = t29;
    $[65] = t31;
  } else {
    t31 = $[65];
  }
  let t32;
  if ($[66] !== t19 || $[67] !== t23 || $[68] !== t27 || $[69] !== t31) {
    t32 = <MoreInfo buttons={[t19, t23, t27, t31]} className="relative z-10" />;
    $[66] = t19;
    $[67] = t23;
    $[68] = t27;
    $[69] = t31;
    $[70] = t32;
  } else {
    t32 = $[70];
  }
  let t33;
  if ($[71] === Symbol.for("react.memo_cache_sentinel")) {
    t33 = <div className="bgCircle absolute right-0 bottom-0 translate-x-1/4 translate-y-1/4 rotate-180" />;
    $[71] = t33;
  } else {
    t33 = $[71];
  }
  let t34;
  if ($[72] !== t32) {
    t34 = <div className="relative overflow-hidden bg-blue-100">{t32}{t33}</div>;
    $[72] = t32;
    $[73] = t34;
  } else {
    t34 = $[73];
  }
  let t35;
  if ($[74] !== menuPromoBanners || $[75] !== t14 || $[76] !== t2 || $[77] !== t34 || $[78] !== t9) {
    t35 = <Layout menuPromoBanners={menuPromoBanners}>{t2}{t9}{t10}{t14}{t15}{t34}</Layout>;
    $[74] = menuPromoBanners;
    $[75] = t14;
    $[76] = t2;
    $[77] = t34;
    $[78] = t9;
    $[79] = t35;
  } else {
    t35 = $[79];
  }
  return t35;
}